import React from 'react';
import { Box } from '@mui/system';
import { FlexyTabs, OptionsType, TabStructure } from '@europrocurement/flexy-components';
import { UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { User } from '../../../types/type';
import { UserHeader } from '../UserHeader';
import { UserInfos, UserInfosProps } from '../UserInfos';
import { UserG3 } from '../UserG3/UserG3';
import { UserL2DF } from '../UserL2DF/UserL2DF';
import { UserCompo } from '../UserCompo/UserCompo';
import { UserGestionJustif } from '../UserGestionJustif/UserGestionJustif';
import { UserAnnuaire } from '../UserAnnuaire/UserAnnuaire';
import { UserSupport } from '../UserSupport/UserSupport';
import { UserGroupesTravail } from '../UserGroupesTravail/UserGroupesTravail';
import { UserAvatar } from '../UserAvatar/UserAvatar';

export type UserPatchPayload = {
    field: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur;
};

export type UserTabsProps = {
    user: User;
    loggedUser: string | undefined;
    poles: OptionsType;
    services: OptionsType;
    groupes: OptionsType;
    marques: OptionsType;
    antennes: OptionsType;
    handlePatchData: (
        payload: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur,
    ) => void;
    handlePatchInfos: UserInfosProps['handlePatchInfos'];
    handleValidationModal: (
        payload: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur,
        field: string,
        value: boolean,
    ) => void;
    synchroniseWithKCAccount: (id: number) => void;
};

export const UserTabs: React.FunctionComponent<UserTabsProps> = function ({
    user,
    loggedUser,
    poles,
    services,
    groupes,
    marques,
    antennes,
    handlePatchData,
    handlePatchInfos,
    handleValidationModal,
    synchroniseWithKCAccount,
}) {
    const tabs: Array<TabStructure> = [
        {
            tabTitle: 'Infos utilisateur',
            tabPanel: (
                <UserInfos
                    poles={poles}
                    services={services}
                    groupes={groupes}
                    antennes={antennes}
                    user={user}
                    handlePatchInfos={handlePatchInfos}
                    handleValidationModal={handleValidationModal}
                />
            ),
            tabName: 'utilisateur',
        },
        {
            tabTitle: 'G3',
            tabPanel: (
                <UserG3
                    user={user}
                    handlePatchData={handlePatchData}
                    marques={marques}
                />
            ),
            tabName: 'G3',
        },
        {
            tabTitle: 'L2D Formalités',
            tabPanel: (
                <UserL2DF
                    user={user}
                    handlePatchData={handlePatchData}
                />
            ),
            tabName: 'L2DF',
        },
        {
            tabTitle: 'Gestion Justif',
            tabPanel: (
                <UserGestionJustif
                    user={user}
                    handlePatchData={handlePatchData}
                />
            ),
            tabName: 'Justif',
        },
        {
            tabTitle: 'Compo',
            tabPanel: (
                <UserCompo
                    user={user}
                    handlePatchData={handlePatchData}
                />
            ),
            tabName: 'composition-annonces',
        },
        {
            tabTitle: 'Annuaire',
            tabPanel: (
                <UserAnnuaire
                    user={user}
                    handlePatchData={handlePatchData}
                />
            ),
            tabName: 'annuaire',
        },
        {
            tabTitle: 'Support',
            tabPanel: (
                <UserSupport
                    user={user}
                    handlePatchData={handlePatchData}
                />
            ),
            tabName: 'support',
        },
        {
            tabTitle: 'Groupes de travail',
            tabPanel: <UserGroupesTravail user={user} />,
            tabName: 'groupe-travail',
        },
        {
            tabTitle: 'Avatar',
            tabPanel: <UserAvatar user={user} />,
            tabName: 'avatar',
        },
    ];

    return (
        <Box>
            <UserHeader
                user={user}
                loggedUser={loggedUser}
                synchroniseWithKCAccount={synchroniseWithKCAccount}
            />

            <FlexyTabs
                tabs={tabs}
                scrollbar={false}
            />
        </Box>
    );
};
